'use client'

import { dismiss, getCurrent, subscribe } from '../../../../store/toastStore'
import type { ToastOptions } from '@lib/store/toastStore'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { Toast } from './Toast'

export const ToastHost = ({}): ReactElement => {
    const [current, setCurrent] = useState<ToastOptions | null>(getCurrent())
    const [exiting, setExiting] = useState<ToastOptions | null>(null)
    const previousCurrent = useRef<ToastOptions | null>(getCurrent())

    useEffect(() => {
        setCurrent(getCurrent())
        const unsubscribe = subscribe((next) => {
            const previous = previousCurrent.current
            previousCurrent.current = next
            /* When the store goes to null we keep the toast in exiting so the leave animation can run; only after onLeaveComplete do we unmount. When a new toast is shown we display it immediately and clear exiting. */
            if (previous != null && next == null) {
                setExiting(previous)
                setCurrent(null)
            } else {
                setCurrent(next)
                setExiting(null)
            }
        })
        return unsubscribe
    }, [])

    const handleLeaveComplete = (): void => {
        setExiting(null)
    }

    const toastOptions = exiting ?? current
    if (toastOptions == null) return <></>

    const isLeaving = exiting != null

    return (
        <Toast
            message={toastOptions.message}
            variant={toastOptions.variant}
            actionText={toastOptions.actionText}
            onAction={toastOptions.onAction}
            onRemove={isLeaving ? undefined : () => dismiss()}
            isLeaving={isLeaving}
            onLeaveComplete={handleLeaveComplete}
        />
    )
}
